import { render, staticRenderFns } from "./customer-list.vue?vue&type=template&id=abb34a2c&scoped=true"
import script from "./customer-list.vue?vue&type=script&lang=js"
export * from "./customer-list.vue?vue&type=script&lang=js"
import style0 from "./customer-list.vue?vue&type=style&index=0&id=abb34a2c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb34a2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abb34a2c')) {
      api.createRecord('abb34a2c', component.options)
    } else {
      api.reload('abb34a2c', component.options)
    }
    module.hot.accept("./customer-list.vue?vue&type=template&id=abb34a2c&scoped=true", function () {
      api.rerender('abb34a2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/terminal_order/terminal_fee/form/customer-list.vue"
export default component.exports